function Footer(): JSX.Element {
  return <div className="footer"></div>;
}

export default Footer;
